// Search-box matching for the Estimate Engine's admin lists (Items,
// Assemblies, Rooms, Layers, …). Every word typed must appear somewhere in the
// row (case-insensitive, any order), so "01 50 hepa" finds a HEPA item under
// cost code 01 50 00. The row's own plain values (text, numbers, codes) are
// searched; `extra` adds text the row only shows through a lookup (a layer or
// cost-code name, a UOM label) so the box matches what the person sees.

const norm = (s) => String(s ?? "").toLowerCase();

export function searchWords(query) {
  return norm(query).split(/\s+/).filter(Boolean);
}

export function rowSearchText(row, extra = []) {
  const parts = [];
  if (row && typeof row === "object") {
    for (const v of Object.values(row)) {
      if (v == null || typeof v === "object") continue;
      parts.push(String(v));
    }
  } else if (row != null) {
    parts.push(String(row));
  }
  for (const e of [].concat(extra)) if (e != null && e !== "") parts.push(String(e));
  return norm(parts.join(" "));
}

export function rowMatchesQuery(row, query, extra = []) {
  const words = searchWords(query);
  if (!words.length) return true;
  const text = rowSearchText(row, extra);
  return words.every((w) => text.includes(w));
}

export function filterRows(rows, query, extraOf) {
  if (!searchWords(query).length) return rows;
  return (rows || []).filter((r) => rowMatchesQuery(r, query, extraOf ? extraOf(r) : []));
}
